var map = {
	"./template.bet575": 1101,
	"./template.bet575.tsx": 1101,
	"./template.bet777": 1102,
	"./template.bet777.tsx": 1102,
	"./template.betblast": 1103,
	"./template.betblast.tsx": 1103,
	"./template.betprofessor": 1104,
	"./template.betprofessor.tsx": 1104,
	"./template.betroyale": 1105,
	"./template.betroyale.tsx": 1105,
	"./template.betstride": 1106,
	"./template.betstride.tsx": 1106,
	"./template.buffalobet": 1107,
	"./template.buffalobet.tsx": 1107,
	"./template.chromabet": 1108,
	"./template.chromabet.tsx": 1108,
	"./template.default": 716,
	"./template.default.tsx": 716,
	"./template.fiestabet": 2047,
	"./template.fiestabet.tsx": 2047,
	"./template.gigabet": 1116,
	"./template.gigabet.tsx": 1116,
	"./template.goldenbet888": 1117,
	"./template.goldenbet888.tsx": 1117,
	"./template.goldenrush": 1118,
	"./template.goldenrush.tsx": 1118,
	"./template.hyperbet": 1119,
	"./template.hyperbet.tsx": 1119,
	"./template.juicybet": 2048,
	"./template.juicybet.tsx": 2048,
	"./template.junglebet": 2049,
	"./template.junglebet.tsx": 2049,
	"./template.magnumbet": 1120,
	"./template.magnumbet.tsx": 1120,
	"./template.oldgill": 1121,
	"./template.oldgill.tsx": 1121,
	"./template.puntcity": 1122,
	"./template.puntcity.tsx": 1122,
	"./template.puntgenie": 2050,
	"./template.puntgenie.tsx": 2050,
	"./template.pyramidbet": 1123,
	"./template.pyramidbet.tsx": 1123,
	"./template.questbet": 1124,
	"./template.questbet.tsx": 1124,
	"./template.slambet": 1125,
	"./template.slambet.tsx": 1125,
	"./template.sterlingparker": 1126,
	"./template.sterlingparker.tsx": 1126,
	"./template.sugarcastle": 1127,
	"./template.sugarcastle.tsx": 1127,
	"./template.templebet": 1128,
	"./template.templebet.tsx": 1128,
	"./template.titanbet": 1129,
	"./template.titanbet.tsx": 1129,
	"./template.ts": 968,
	"./template.vikingbet": 1130,
	"./template.vikingbet.tsx": 1130,
	"./template.volcanobet": 1131,
	"./template.volcanobet.tsx": 1131,
	"./template.wellbet": 1132,
	"./template.wellbet.tsx": 1132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2418;